import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EntityTypes } from '@guryou/core';
import { DELETE_GROUP_FOR_MEMBERSHIP, getGroups, StateStatus } from '@guryou/redux';

import { resetState } from '../actions';
import { GROUPS_CREATE, GROUPS_UPDATE, PROVIDER_DELETE_GROUP, resetGroupsState } from '../new/group';

const useGroups = ({ type, groupId }) => {
  const dispatch = useDispatch();
  const { data, status, version, entity, request } = useSelector(state => state.groups.all);
  const groupsCreate = useSelector(state => state.groups.create);
  const groupsUpdate = useSelector(state => state.groups.update);
  const groupsDelete = useSelector(state => state.groups.delete);
  const deleteGroup = useSelector(state => state.membership.deleteGroup);

  useEffect(() => {
    if (status === StateStatus.LOADING) {
      return;
    }
    if (status === StateStatus.NOT_INITIALIZED || (status === StateStatus.LOADED && request?.type !== type)) {
      dispatch(getGroups(type));
      return;
    }
    if (groupsCreate.status === StateStatus.LOADED) {
      dispatch(resetState(GROUPS_CREATE));
      dispatch(resetGroupsState());
    }
    if (groupsUpdate.status === StateStatus.LOADED) {
      dispatch(resetState(GROUPS_UPDATE));
      dispatch(resetGroupsState());
    }
    if (groupsDelete.status === StateStatus.LOADED) {
      dispatch(resetState(PROVIDER_DELETE_GROUP));
      dispatch(resetGroupsState());
    }
    if (deleteGroup.status === StateStatus.LOADED && type === EntityTypes.membership) {
      dispatch(resetState(DELETE_GROUP_FOR_MEMBERSHIP));
      dispatch(resetGroupsState());
    }
  }, [data, dispatch, deleteGroup.status, groupsCreate.status, groupsDelete.status, groupsUpdate.status, request, status, type]);

  if (groupId) {
    return { group: (data || []).find(x => x.id === groupId), status, version, entity };
  }

  return { data: data || [], status, version, entity };
};

export default useGroups;
